// extracted by mini-css-extract-plugin
module.exports = {"btns":"ActionsEditDelete_btns__14Bf6","editBtn":"ActionsEditDelete_editBtn__1B3On","deleteBtn":"ActionsEditDelete_deleteBtn__2XPHP"};